import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import "./About.scss";
import { urlFor,client } from "../../client";

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]'

    client.fetch(query)
      .then((data) => {
        setAbouts(data);
      })
  },[])

  return (
    <>
      <h2 className="head-text">I know That <span>Good Developement</span> <br /> means <span>Good business</span></h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            className="app__profile-item"
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 data-tip data-for={about.title} className="bold-text" style={{ marginTop:20}}>{about.title}</h2>
            <p className="p-text" style={{ marginTop:10}}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

// export default About;
export default AppWrap(MotionWrap(About, 'app__about'), 'about', 'app__whitebg');